export default {
    share_label_1: '¡Diles a tus amigos',
    share_label_2: 'que no la c*guen!',
};
